const max = 5;

// Watch cart store and source from Shopify Search & Discovery API
export const cartRecommendations = () => ({
  data: [],

  async getRecommendations(productIds) {
    const promises = productIds.map((id) => getIndividualRecommendation(id));
    const results = await Promise.all(promises);

    this.data = results.flat()?.reduce((acc, item) => {
      if (acc.length < max && !acc.find((r) => r.id === item.id)) {
        acc.push(item);
      }
      return acc;
    }, []);

    async function getIndividualRecommendation(productId) {
      const id = productId || this.$store.cart.items[0].product_id;
      const url = `/recommendations/products?product_id=${id}&section_id=cart-recommendations&intent=complementary&limit=${max}`;

      // get fetch request
      try {
        const response = await fetch(url, { method: "GET" });
        const text = await response.text();
        const products = extractJSONFromHTML(
          text,
          "#product-recommendations-json"
        );
        const holder = [];
        products?.forEach((product) => {
          if (!holder.find((r) => r.id === product.id)) {
            holder.push(product);
          }
        });

        return holder;
      } catch (error) {
        console.error("Error fetching recommendations", error);
      }
    }
  },

  async init() {
    this.$watch("$store.cart.items", async (newvalue, oldvalue) => {
      // If cart is not open, then don't fetch recommendations
      // if (this.$store.cart.open === false) return;
      // If number of items in the cart is 0, or hasn't changed, then don't fetch recommendations
      if (newvalue.length === 0 || newvalue.length === oldvalue.length) return;

      // Loop through each item in the cart to get recommendations for each, then remove duplicated and update the data
      const productIds = newvalue
        // sort by original_price
        .sort((a, b) => b.original_price - a.original_price)
        // get product_id
        .map((item) => item.product_id)
        // Maximum of 2 items in the array
        .slice(0, max);

      const uniqueProductIds = [...new Set(productIds)];
      this.getRecommendations(uniqueProductIds);
    });
  },
});

export const cartRecommendation = (product, imgSize) => ({
  product,
  variantId: null,
  open: false,

  get selectedVariant() {
    if (!this.variantId) return this.product?.variants?.[0];
    const selected = this.product?.variants?.find(
      (r) => r.id === parseInt(this.variantId)
    );
    return selected;
  },
  get selectedImage() {
    const img =
      this.selectedVariant?.featured_image?.src || this.product?.featured_image;
    const size = imgSize || 200;
    return img
      ? (img.startsWith("https://") ? "" : "https://") +
          img +
          `&width=${size}&height=${size}`
      : "";
  },
  get selectedPrice() {
    const price = this.selectedVariant?.price || this.product?.price;
    return this.$store.cart.formatMoney(price);
  },
  get selectedCompareAtPrice() {
    const price =
      this.selectedVariant?.compare_at_price || this.product?.compare_at_price;
    return this.$store.cart.formatMoney(price);
  },
  async addToCart() {
    // Add to cart where no variant
    if (product.variants?.length <= 1) {
      await this.$store.cart.addVariant(
        this.selectedVariant?.id || this.product.variants[0].id
      );
    } else {
      this.open
        ? this.$store.cart.addVariant(this.selectedVariant?.id)
        : (this.open = true);
    }
  },
});

function extractJSONFromHTML(html, selector) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const script = doc?.querySelector(selector);
  if (!script) return;
  let json = script.textContent.trim();
  if (json.endsWith(";")) json = json.slice(0, -1);
  const data = JSON.parse(json);
  return data;
}

// DEPRECATED: Sourced from Rebuy
export const Recommendations = (productId) => ({
  // Properties
  base: `https://rebuyengine.com/api/v1/products/recommended`,
  recommendations: [],
  get endpoint() {
    const requestParameters = new URLSearchParams({
      shopify_product_ids: productId,
      format: "pretty",
      metafields: true,
      key: "2fa29bf1509955326b00b03d05650b077e035ac3",
      limit: 4,
    });

    return this.base + "?" + requestParameters.toString();
  },
  // Methods
  getRecommendations() {
    // Fetch from Rebuy API
    fetch(this.endpoint).then((response) =>
      response.json().then((data) => {
        this.recommendations = data;
        // console.log(data);
      })
    );
  },

  // Init
  init() {
    this.getRecommendations();
  },
});
